import React from "react";
import { Link } from "react-router-dom";

import Hamburger from "./Hamburger";
import routes from "../../data/routes";

// Websites Navbar, displays routes defined in 'src/data/routes'
const Navigation = () => (
  <header id="header">
    {routes
      .filter((l) => l.index)
      .map((l) => (
        <Link
          className="index-link"
          style={{ borderBottom: "none" }}
          key={l.label}
          to={l.path}
        >
          <h1>{l.label}</h1>
        </Link>
      ))}
    <nav className="links">
      <ul>
        {routes
          .filter((l) => !l.index)
          .map((l) => (
            <li key={l.label}>
              <Link to={l.path}>{l.label}</Link>
            </li>
          ))}
      </ul>
    </nav>
    <Hamburger />
  </header>
);

export default Navigation;
